

import { LogLevel } from "@azure/msal-browser";
import { getActiveDirectoryConfig } from './env';

 const getAzureCredentials = () => {
     const clientId = getActiveDirectoryConfig().clientId;
     const authorityKey = `57952406-af28-43c8-b4de-a4e06f57476d`;
     return { clientId, authorityKey };
 };

export const msalConfig = {
    auth: {
        navigateToLoginRequestUrl: false,
        clientId: getAzureCredentials().clientId,
        authority: `https://login.microsoftonline.com/${getAzureCredentials().authorityKey}`,
        redirectUri: getActiveDirectoryConfig().redirectUri
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        return;		
                    case LogLevel.Info:				
                        return;		
                    case LogLevel.Verbose:		
                        return;		
                    case LogLevel.Warning:			
                        return;		
                }	
            }	
        }	
    },
    
};

export const loginRequest = {
    scopes: [getActiveDirectoryConfig().scope, "User.Read", "offline_access"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};